import $ from 'jquery';
import SyosEvents from './utils/SyosEvents';
import { templateCart } from './templates/templates';
import SyosUiContainer from './SyosUiContainer';
import { StateClass } from './SyosGlobalConfig';
import syosMediaQuery from './utils/syosMediaQuery';
import { toggleBodyClass } from './utils/html';
import GestureHelper from './utils/GestureHelper';
import SyosPageComponent from './SyosPageComponent';

/** @typedef {import("../tnew/currency/CurrencyFormatter").default} CurrencyFormatter */


const CLASS_RENDER_TARGET = 'tn-syos-cart__render-target';
const CLASS_DISMISS = 'tn-syos-cart__dismiss';
const CLASS_CONTENT_CONTAINER = 'tn-syos-cart__content-container';
const CLASS_HEADING = 'tn-syos-cart__heading';

const HTML = `
  <div class="tn-syos-mobile-overlay__scroll-content-wrapper">
    <div class="${CLASS_CONTENT_CONTAINER}">
      <div class="tn-syos-cart__header">
        <h3 class="${CLASS_HEADING}"></h3>

        <button type="button" class="tn-modal__btn-close tn-syos-cart__dismiss" aria-label="Close">
          <div aria-hidden="true" class="close-icon"></div>
        </button>
      </div>
      <div class="${CLASS_RENDER_TARGET}"></div>
    </div>
  </div>
`;

class SyosCartContainer extends SyosUiContainer {
  constructor(syosController, currencyFormatter) {
    super(syosController, '.tn-syos-cart');
    this.bindMethods();
    this.currencyFormatter = currencyFormatter;
    this.isExpanded = false;

    this.seats = new Map();

    this.syosController.on(SyosEvents.SEAT_SELECTED, this.onSeatSelected);
    this.syosController.on(SyosEvents.SEAT_REMOVED, this.onSeatRemoved);
    this.syosController.on(SyosEvents.CART_DETAILS_TOGGLE, this.toggleDetails);

    this.$el.html(HTML);
    this.$container = this.find(`.${CLASS_CONTENT_CONTAINER}`);
    this.$renderTarget = this.find(`.${CLASS_RENDER_TARGET}`);

    const { selectedSeatsHeader } = SyosPageComponent;

    const $heading = this.find(`.${CLASS_HEADING}`);
    $heading.html(selectedSeatsHeader);

    this.$el.on('click', '.tn-syos-cart-seat__btn-remove', this.onSeatBtnRemoveClick);
    this.$el.on('click', '.tn-syos__btn-add-to-cart', () => {
      if (syosMediaQuery.testIsMobile()) {
        this.hideDetails();
      }
      this.syosController.emit(SyosEvents.RESERVE_SEATS);
    });

    this.$el.on('click', `.${CLASS_DISMISS}`, (event) => {
      event.preventDefault();
      this.hideDetails();
    });

    this.dismissHandler = new GestureHelper(document.body, {
      onClick: this.onDismissClick,
    });

    this.update();
  }

  bindMethods() {
    this.onSeatSelected = this.onSeatSelected.bind(this);
    this.onSeatRemoved = this.onSeatRemoved.bind(this);
    this.onSeatBtnRemoveClick = this.onSeatBtnRemoveClick.bind(this);
    this.toggleDetails = this.toggleDetails.bind(this);
    this.onDismissClick = this.onDismissClick.bind(this);
  }

  onDismissClick(event) {
    if (syosMediaQuery.testIsMobile()) {
      if (this.testEventOccuredInPopover(event) === false) {
        event.preventDefault();
        this.hideDetails();
      }
    }
  }

  testEventOccuredInPopover(event) {
    return this.$container[0].contains(event.target);
  }


  getSubtotal() {
    const seats = this.seats;

    if (seats.size === 0) {
      return 0;
    }

    return Array.from(seats.values())
      .reduce((sum, seat) => sum + seat.priceWithFee, 0);
  }

  getSeatForId(id) {
    if (this.seats.has(id)) {
      return this.seats.get(id);
    }
    return null;
  }

  isSeatInCart(seat) {
    return this.seats.has(seat.id);
  }

  onSeatSelected({ seat }) {
    this.seats.set(seat.id, seat);
    this.update();
  }

  onSeatRemoved({ seat }) {
    this.seats.delete(seat.id);
    this.update();
  }

  getSeats() {
    return this.seats;
  }

  getSeatCount() {
    return this.seats.size;
  }

  maximumSeatCountReached() {
    const maxSeats = this.syosController.getMaximumSeatCount();
    return maxSeats > 0 && this.seats.size >= maxSeats;
  }

  empty() {
    this.seats.forEach(seat => seat.removeFromCart());
  }

  update() {
    const { addToCartButton, subtotalLabel } = SyosPageComponent;

    const seats = Array.from(this.seats.values());
    const numSeats = seats.length;
    const subtotal = this.currencyFormatter.format(this.getSubtotal());

    this.$renderTarget.html(templateCart.render({
      seats,
      subtotal,
      addToCartButton,
      subtotalLabel,
    }));

    if (numSeats === 0) {
      this.hideDetails();
    }

    this.syosController.emit(SyosEvents.CART_UPDATE, { cart: this });
  }

  toggleDetails() {
    if (this.isExpanded) {
      this.hideDetails();
    } else {
      this.showDetails();
    }
  }

  showDetails() {
    this.isExpanded = true;
    toggleBodyClass(StateClass.CART_DETAILS_VISIBLE, true);

    if (syosMediaQuery.testIsMobile()) {
      this.$el.show();
    } else {
      this.$el.slideDown({ duration: 200 });
    }

    this.$el[0].scrollTop = 0;

    window.setTimeout(() => { this.dismissHandler.start(); });
  }

  hideDetails() {
    this.isExpanded = false;
    toggleBodyClass(StateClass.CART_DETAILS_VISIBLE, false);
    this.dismissHandler.stop();

    if (syosMediaQuery.testIsMobile()) {
      this.$el.hide();
    } else {
      this.$el.slideUp({ duration: 200 });
    }
  }

  onSeatBtnRemoveClick(event) {
    const $btn = $(event.currentTarget);
    const seatId = $btn.data('tn-seat-id');
    this.seats.get(seatId).removeFromCart();
  }
}

export default SyosCartContainer;



// WEBPACK FOOTER //
// ./V7/syos/SyosCartContainer.js